export enum TextLabels {
  ORDERS = "Orders",
}

export const noImageFileURL =
  "https://garaaz-store.s3.ap-south-1.amazonaws.com/12f9acad4db84044a016377125fbd8c5.jpg";
export const fileDownloadImage =
  "https://garaaz-store.s3.amazonaws.com/088189fc8241416d8a9c79cee875d4e2.png";

export const epochPlatformEtaSeconds = -19800;

export enum OrderStatus {
  NEW = "NEW",
  CANCELLED = "CANCELLED",
  ENQUIRY_CLOSED = "ENQUIRY_CLOSED",
  CANCEL = "CANCEL",
  DELETED = "DELETED",
  CBO = "CBO",
  ACK = "ACK",
  READY = "READY",
  COMPLETED = "COMPLETED",
  COMPLETE = "COMPLETE",
  ALLOCATE = "ALLOCATE",
  ALLOCATED = "ALLOCATED",
  REVOKED = "REVOKED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  READY_TO_DISPATCH = "READY_TO_DISPATCH",
  RETURN_REQUESTED = "RETURN_REQUESTED",
  CUSTOMER_RETURNED = "CUSTOMER_RETURNED",
  CUSTOMER_RETURN_REJECTED = "CUSTOMER_RETURN_REJECTED",
  SUPPLIER_RETURNED = "SUPPLIER_RETURNED",
  SUPPLIER_RETURN_REJECTED = "SUPPLIER_RETURN_REJECTED",
  DELIVERED = "DELIVERED",
  CUSTOMER_HOLD = "CUSTOMER_HOLD",
}

export function getGaraazStateColor(stateName: OrderStatus) {
  switch (stateName) {
    case OrderStatus.NEW:
      return "#92E6A7";
    case OrderStatus.ACK:
      return "#FF8C00";
    case OrderStatus.ENQUIRY_CLOSED:
      return "#1A7431";
    case OrderStatus.DELIVERED:
      return "#1A7431";
    case OrderStatus.ALLOCATED:
      return "#07BEB8";
    case OrderStatus.CBO:
      return "#936639";
    case OrderStatus.CANCELLED:
      return "#85182A";
    case OrderStatus.READY_TO_DISPATCH:
      return "#BFAB25";
    case OrderStatus.RETURN_REQUESTED:
      return "#92E6A7";
    case OrderStatus.CUSTOMER_RETURNED:
      return "#2DC653";
    case OrderStatus.CUSTOMER_RETURN_REJECTED:
      return "#E01E37";
    case OrderStatus.SUPPLIER_RETURNED:
      return "#1A7431";
    case OrderStatus.SUPPLIER_RETURN_REJECTED:
      return "#E01E37";
    case OrderStatus.ACCEPTED:
      return "#1A7431";
    case OrderStatus.REJECTED:
      return "#E01E37";
    case OrderStatus.CUSTOMER_HOLD:
      return "#e5383b";
  }
}

export function getSupplierStateColor(stateName: OrderStatus) {
  switch (stateName) {
    case OrderStatus.NEW:
      return { color: "#92E6A7", textColor: "black" };
    case OrderStatus.ACK:
      return { color: "#FF8C00", textColor: "black" };
    case OrderStatus.CBO:
      return { color: "#936639", textColor: "white" };
    case OrderStatus.REVOKED:
      return { color: "#9932CC", textColor: "white" };
    case OrderStatus.READY:
      return { color: "#1A7431", textColor: "white" };
    case OrderStatus.CANCELLED:
      return { color: "#85182A", textColor: "white" };
    case OrderStatus.RETURN_REQUESTED:
      return { color: "#92E6A7", textColor: "black" };
    case OrderStatus.ACCEPTED:
      return { color: "#1A7431", textColor: "white" };
    case OrderStatus.REJECTED:
      return { color: "#E01E37", textColor: "white" };
  }
}

export enum OrderActions {
  CUSTOMER_RETURNED = "CUSTOMER_RETURN_ACCEPT",
  CUSTOMER_RETURN_REJECTED = "CUSTOMER_RETURN_REJECT",
  SUPPLIER_RETURNED = "SUPPLIER_RETURN_ACCEPT",
  SUPPLIER_RETURN_REJECTED = "SUPPLIER_RETURN_REJECT",
  ACCEPT = "ACCEPT",
  REJECT = "REJECT",
  CUSTOMER_UNHOLD = "CUSTOMER_UNHOLD",
}

export enum ORDER {
  ALLGARAAZORDERS = "ALLGARAAZORDERS",
  ORDERHANDLER = "ORDERHANDLER",
  GET_ALL_SUPPLIERS = "GET_ALL_SUPPLIERS",
  BRANDS_INFO = "BRANDS_INFO",
  ACTIVE_SUBSCRIPTION_CUSTOMERS = "ACTIVE_SUBSCRIPTION_CUSTOMERS",
  SINGLEGARAAZORDER = "SINGLEGARAAZORDER",
  ORDERSTATSBYORDERHANDLER = "ORDERSTATSBYORDERHANDLER",
  ALLORDERHANDLERS = "ALLORDERHANDLERS",
  SAMEPARTORDERS = "SAMEPARTORDERS",
  CARMAKERS = "CARMAKERS",
  SUPPLIER_PART_AVAILABILITY = "SUPPLIER_PART_AVAILABILITY",
}

export enum CUSTOMERS {
  UNIQUECUSTOMERSTODAY = "UNIQUECUSTOMERSTODAY",
  DISTINCT_CUSTOMER_STATES = "DISTINCT_CUSTOMER_STATES",
  UNIQUECUSTOMERYESTERDAYANDTHISMONTH = "UNIQUECUSTOMERYESTERDAYANDTHISMONTH",
}

export enum OrdersTextLabels {
  ORDER_DELETED = "Order deleted successfully!",
  SOMETHING_WENT_WRONG = "Something went wrong",
  ERROR_ON_FILE_LOAD = "Error occurred while extracting file contents",
  INVOICE_UPLOADED_SUCCESSFULLY = "Invoice uploaded successfully!",
  CHALLAN_UPLOADED_SUCCESSFULLY = "Challan uploaded successfully",
  INVALID_PDF_CONTENT = "Please ensure that the Invoice number does not exceed 16 characters. It can contain alphabets, numerals, hyphens(-), and/or slash(/).",
  ACCESS_DENIED_ORDER_STATUS_INVALID = "Action Denied : Order State Invalid!",
  CBO_STATE_INVALID = "Action Denied : Order State Invalid or Requested Supplier State Invalid",
}

export enum CustomerType {
  PLATFORM = "PLATFORM",
  SUBSCRIBED = "Subscribed",
  PPD = "PPD",
  XPRESS = "Xpress",
}

export enum Roles {
  OPERATIONS_LEAD = "OPERATIONS_LEAD",
  EXECUTIVE = "EXECUTIVE",
  HEAD_OF_OPERATIONS = "HEAD_OF_OPERATIONS",
}

export enum EngagementMode {
  PLATFORM = "PLATFORM",
  SUBSCRIBED = "SUBSCRIBED",
  EXPIRED = "EXPIRED",
}

export enum PaymentType {
  PREPAID = "PREPAID",
  POSTPAID = "POSTPAID",
}

export enum DeliveryModes {
  DOOR_DELIVERY = "DOOR_DELIVERY",
  SELF_PICKUP = "SELF_PICKUP",
}

export enum CPTSlabForManualOption {
  DIRECT_DELIVERY = 1,
  AGGREGATED_DELIVERY = 2,
}

export const CPTSlabManualDisplay: Record<CPTSlabForManualOption, string> = {
  [CPTSlabForManualOption.DIRECT_DELIVERY]: "Direct Delivery",
  [CPTSlabForManualOption.AGGREGATED_DELIVERY]: "Aggregated Delivery",
};

export enum TransactionType {
  FACILITATION = "Facilitation",
  TRADING = "Trading",
}

export enum OrderTypes {
  REGULAR = "REGULAR",
  VIRTUAL = "VIRTUAL",
  RETURN = "RETURN",
  SUBSCRIPTION = "SUBSCRIPTION",
}

export enum OrderHandlerAllocationType {
  PARENT = "Parent",
  RANDOM = "Random",
}

export enum InvoiceStatus {
  PAID = "PAID",
  UNPAID = "UNPAID",
  RECEIVED = "RECEIVED",
}

export enum VehicleType {
  TWO_WHEELER = "TWO_WHEELER",
  THREE_WHEELER = "THREE_WHEELER",
  OTHER = "OTHER",
}

export enum BillingEntity {
  INSURANCE_COMPANY = "INSURANCE_COMPANY",
  CUSTOMER = "CUSTOMER",
  END_CUSTOMER = "END_CUSTOMER",
}

export enum OrderPopoverLabels {
  PARENT = "PARENT",
  ENQUIRY = "ENQUIRY",
  PARENT_ORDER_NO = "Parent Order No.",
  ENQUIRY_NO = "Enquiry No.",
}
